// TODO this is a workaround for fixing bug related to async select components menu opening at
//  the bottom of input field even if there is no place, and causing document body overflow.
//  (also overflow hidden for document body, and div with containerRef added for this purpose)
//  This all will be removed after issue fixed from react-select side
//  https://github.com/JedWatson/react-select/issues/5642
import { useCallback, useRef, useState } from 'react';

import { type MenuPlacement } from 'react-select';

import useIntersectionObserver from './useIntersectionObserver';

function useMenuPlacement() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [menuPlacement, setMenuPlacement] = useState<MenuPlacement>('auto');

  const changeMenuPlacement = useCallback((isIntersecting: boolean) => {
    if (isIntersecting) {
      setMenuPlacement('bottom');
    } else {
      setMenuPlacement('top');
    }
  }, []);

  useIntersectionObserver({
    element: containerRef,
    callback: changeMenuPlacement,
    rootMargin: '0px 0px -360px',
  });

  return {
    containerRef,
    menuPlacement,
  };
}

export default useMenuPlacement;
